/**
 * Tri de la colonne gauche du secretariat.
 *
 * Nicolas, 11/09 : pouvoir trier par salle ou par Mode direct, et voir
 * d'un coup d'oeil les prises en charge a domicile / etablissement.
 */

export function nomLieu(appt, roomNames = {}) {
  if (appt?.modeDirect) return "Mode direct";
  if (appt?.roomId && roomNames[appt.roomId]) return roomNames[appt.roomId];
  return "Sans salle";
}

function secondes(ts) {
  if (!ts) return 0;
  if (typeof ts.seconds === "number") return ts.seconds;
  if (ts instanceof Date) return Math.floor(ts.getTime() / 1000);
  return 0;
}

export function trierDossiers(liste, mode, roomNames = {}) {
  const copie = [...(liste || [])];
  if (mode === "salle") {
    copie.sort((a, b) => {
      const la = nomLieu(a, roomNames);
      const lb = nomLieu(b, roomNames);
      const cmp = la.localeCompare(lb, "fr", { numeric: true });
      if (cmp !== 0) return cmp;
      return secondes(b.started_at || b.ended_at) - secondes(a.started_at || a.ended_at);
    });
    return copie;
  }
  // Nicolas, 13/09 : « Mode direct » n'affiche QUE les prises en charge
  // directes. Ce n'est pas un tri, c'est un filtre.
  if (mode === "direct") {
    return copie
      .filter((a) => a.modeDirect)
      .sort((a, b) => secondes(b.started_at || b.ended_at) - secondes(a.started_at || a.ended_at));
  }
  copie.sort(
    (a, b) =>
      secondes(b.started_at || b.ended_at) - secondes(a.started_at || a.ended_at)
  );
  return copie;
}
